import { useState } from 'react';

import { Box, Drawer, SxProps, Theme } from '@mui/material';

import { useLanguage } from '../../hooks';
import { ActivatedMobileUserMinimumData, UserGroup } from '../../types';
import { SignersDrawerFooter, SignersDrawerFooterProps } from './SignersDrawerFooter';
import UserDrawerContentSelector from './UserDrawerContentSelector';

const customStyles: Record<string, SxProps<Theme>> = {
  drawerColumn: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
};

interface OwnerDrawerSelectorProps {
  open: boolean;
  onClose: () => void;
  users: ActivatedMobileUserMinimumData[];
  groups: UserGroup[];
  onSave: (users: ActivatedMobileUserMinimumData[]) => void;
  initialSelectedUsers?: ActivatedMobileUserMinimumData[];
}

export function OwnerDrawerSelector({
  open,
  onClose,
  users,
  groups,
  onSave,
  initialSelectedUsers = [],
}: OwnerDrawerSelectorProps) {
  const lang = useLanguage();
  const [owners, setOwners] = useState<ActivatedMobileUserMinimumData[]>([]);

  const handleSave = (selectedUsers: ActivatedMobileUserMinimumData[]) => {
    onSave(selectedUsers);
  };

  const handleOwnersUpdate = (selectedUsers: ActivatedMobileUserMinimumData[]) => {
    setOwners(selectedUsers);
  };

  const footerActions: SignersDrawerFooterProps = {
    onAddButtonClick: () => {
      onSave(owners);
      onClose();
    },
    addButtonDisabled: owners.length === 0,
    onCancelButtonClick: onClose,
  };

  return (
    <Drawer
      anchor='right'
      open={open}
      onClose={onClose}
    >
      <Box sx={customStyles.drawerColumn}>
        <UserDrawerContentSelector
          onClose={onClose}
          users={users}
          groups={groups}
          onSave={handleSave}
          singleUser
          title={lang.formSignatureBuilder.assignOwner}
          initialSelectedUsers={initialSelectedUsers}
          onSignersUpdate={handleOwnersUpdate}
        />
        <SignersDrawerFooter
          onAddButtonClick={footerActions.onAddButtonClick}
          addButtonDisabled={footerActions.addButtonDisabled}
          onCancelButtonClick={footerActions.onCancelButtonClick}
        />
      </Box>
    </Drawer>
  );
}

export default OwnerDrawerSelector;
